import type { ReactNode } from 'react';

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-14 text-center">
      {icon ? <div className="text-[var(--ink-3)]">{icon}</div> : null}
      <div>
        <p className="text-sm font-medium text-[var(--ink)]">{title}</p>
        {description ? (
          <p className="mx-auto mt-1 max-w-sm text-xs text-[var(--ink-3)]">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
